import { Injectable } from '@angular/core';
import { DecimalPipe } from '@angular/common';


declare var jQuery: any;

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  private closePopoverTemplate = `
    <button type="button"
    class="btn btn-light btn-sm close-popover"
    (click)="closePopover()"
    aria-label="Close">&times;</button>`;

  constructor(private decimalPipe: DecimalPipe) { }

  setPopovers() {
    jQuery('[data-toggle="popover"]').popover();
    this.insertClosePopover();
  }

  closePopover() {
    jQuery('[data-toggle="popover"]').popover('hide');
  }

  formatNumber(value: number) {
    return this.decimalPipe.transform(value);
  }

  insertClosePopover() {
    jQuery('.popover.show').append(this.closePopoverTemplate);
  }

}
